import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createProgramDocumentDownloadTicket: (
  fetchContext: FetchContext,
  programDocumentId: number,
  accessToken?: string,
) => Promise<string> = (fetchContext, programDocumentId, accessToken) => (fetch(`${fetchContext.baseUrl}/api/program-documents/${programDocumentId}/download-ticket`,
  {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<string>(fetchContext.errorStore, response, 'create program document download ticket', false))
);
